<template>
  <pages-home-block
    :block="block"
  />
</template>

<script>
// Modules
import PagesHomeBlock from 'pages/home/Block';

// Images
const images = {
  ourMission: require(`images/home/our-mission.svg`),
  tick: require(`images/icons/tick.svg`),
};

export default {
  name: `ui-our-mission`,

  // Compononts
  components: {
    PagesHomeBlock,
  },

  // Data
  data () {
    return {
      block: {
        slug: `why`,
        block: `lightest`,
        image: {
          image: images.ourMission,
          alt: `Our Mission`,
        },
        content: {
          heading: `Building trust through transparency.`,
          copy: [
            `VeriTooth was created to help dentists and patients verify the quality of ` +
            `the work that patients receive. It’s our vision to transform the dental ` +
            `industry by shining a light on high quality work and helping patients get better outcomes.`,
          ],
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// OurMission.vue?6c0a5bc6